import api from "api";

export function getAllSuppliers() {
  return api.get(`get-all-suppliers`);
}

export function addSupplier(supplier){
    return api.post(`add-supplier`,supplier)
}

export function wareHouses(){
  return api.get("get-all-warehouses");
}

export function stockModuleUpdate(payload){
  return api.post("stock-manual-updation", payload);
}

export function getStockReport(wareId, skuId){
  return api.get(`get-warehouse-skus?warehouseId=${wareId}&skuId=${skuId}`);
}

export function stockData(wareId, skuId, displayId){
  return api.get(`get-stock-data?warehouseId=${wareId}&skuId=${skuId}&orderDisplayId=${encodeURIComponent(displayId)}&pageNumber=1&pageSize=null`);

}

export function trackerData(wareId, skuId){
  return api.get(`get-sequence-numbers?warehouseId=${wareId}&skuId=${skuId}&pageNumber=undefined&pageSize=undefined`);
}

export function warehouseInward(payload){
  return api.post("warehouse-inward", payload);
}

export function warehouseInwardData(warehouseId, towardWareId, skuId){
  return api.get(`get-warehouse-inwards?fromWarehouseId=${warehouseId}&toWarehouseId=${towardWareId}&skuId=${skuId}`)
}

export function warehouseOutwardData(warehouseFrom, warehouseTo, skuId){
  return api.get(`get-warehouse-outwards?fromWarehouseId=${warehouseFrom}&toWarehouseId=${warehouseTo}&skuId=${skuId}`)
}

export function warehouseOutwards(payload){
  return  api.post('warehouse-outwards', payload);
}

export function inTransit(fromWareId, toWareId, skuId){
  return api.get(`get-intransit-stock-data?fromWarehouseId=${fromWareId}&toWarehouseId=${toWareId}&skuId=${skuId}`)
}

export const getSkuReport =(payload)=>{
  return api.post(`download-warehouse-report`,payload)
}

export const getManualUpdation =(page)=>{
  return api.get(`warehouse_manual_updation_logs?page=${page}`)
}